import Api from '@/api/index';

import moment from 'moment-timezone'

const DateFilterModule = {
  namespaced: true,
  state: {
    value: 'my value',
    default_date_filter: {
      date_string: `${moment().startOf('month').format('DD/MM/YYYY')} ~ ${moment().endOf('month').format('DD/MM/YYYY')}`,
      date_range: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').add(1, 'day').format('YYYY-MM-DD'),
      ],
      start_date: moment().startOf('month').format('YYYY-MM-DD'),
      end_date: moment().endOf('month').add(1, 'day').format('YYYY-MM-DD'),
      kind: 'date', //'month',
    },
    date_filter: {
      date_string: `${moment().startOf('month').format('DD/MM/YYYY')} ~ ${moment().endOf('month').format('DD/MM/YYYY')}`,
      date_range: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD'),
      ],
      start_date: moment().startOf('month').format('YYYY-MM-DD'),
      end_date: moment().endOf('month').add(1, 'day').format('YYYY-MM-DD'),
      kind: 'date', //'month',
    },
  },
  getters: {
    getDateFilter: state => {
      return state.date_filter;
    },
    getStartDate: state => {
      return state.date_filter.start_date;
    },
    getEndDate: state => {
      return state.date_filter.end_date;
    },
    getDateString: state => {
      return state.date_filter.date_string;
    },
    getDateRange: state => {
      return state.date_filter.date_range;
    },
    getStartEndDate: state => {
      return {
        start_date: state.date_filter.start_date, 
        end_date: state.date_filter.end_date
      };
    },
  },

  mutations: {
    setKind(state, kind){
      let old_k = state.date_filter.kind
      state.date_filter.kind = kind
      
      if (kind == 'month' && old_k != 'month'){
        state.date_filter.date_range = moment().startOf('month').format('YYYY-MM')
        state.date_filter.date_string = `${moment().startOf('month').locale('pt-BR').format('MMM, YYYY')}`
      }
    },
    setDate(state, date){
      state.date_filter = {
        ...state.date_filter,
        ...date
      }
    },

    clearDate(state){
      state.date_filter = {...state.default_date_filter}
    },
  },

  actions: {
    setKind({commit}, kind = 'date'){
      commit('setKind', kind)
    },
    clearDate({commit}){
      commit('clearDate')
      
    },
    setDate({commit}, date_range){
      let date = {}
      if (Array.isArray(date_range) && date_range.length>1){
        // works for date searches, with range value

        date = {
          date_string: `${moment(date_range[0]).format('DD/MM/YYYY')} ~ ${moment(date_range[1]).format('DD/MM/YYYY')}`,
          date_range: [...date_range],
          start_date: date_range[0],
          end_date: moment(date_range[1]).add(1, 'days').format('YYYY-MM-DD'),
          kind: 'date'
        }

      } else if (Array.isArray(date_range) && date_range.length == 1) {
        // works for date searches, just start value, end-date is +1 day

        date = {
          date_string: `${moment(date_range[0]).format('DD/MM/YYYY')}`,
          date_range: [date_range],
          start_date: date_range[0],
          end_date: moment(date_range[0]).add(1, 'days').format('YYYY-MM-DD'),
          kind: 'date'
        }

      } else if (typeof(date_range) == 'string' && date_range.length>1){
        // works for month searches, like on solution resolve or covid
        
        date = {
          date_string: `${moment(date_range).locale('pt-BR').format('MMM., YYYY')}`,
          date_range: date_range,
          start_date: moment(date_range).startOf('month').format('YYYY-MM-DD'),
          end_date: moment(date_range).endOf('month').add(1,'days').format('YYYY-MM-DD'),
          kind: 'month'
        }
      }
      commit('setDate', date)
    },

    
  }

};

export default DateFilterModule;